import axios from 'axios'
import store from '../store'
import router from '../router'
import bus from '../common/bus';
export class Axios {
  get(url, params) {
    let paramArr = []
    const token = store.state.LoginInfo.token
    if (token && !params) {
      params = {token: token}
    }
    if (params) {
      if (!params.token && token) {
        params.token = token
      }
      for (let k in params) {
        paramArr.push(k + '=' + params[k])
      }
    }
    if (paramArr.length) {
      url = url + (url.indexOf('?') > -1 ? '&' : '?') + paramArr.join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
    })
  }
  post(url, params = {}, urlencoded) {
    const token = store.state.LoginInfo.token
    if (token) {
      params.token = token
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'token=' + token
    }
    const requestBody = {
      method: 'POST',
      url: url
    }
    if (params) {
      if (urlencoded) {
        requestBody.params = params
      } else {
        requestBody.data = params
      }
    }
    return new Promise((resolve, reject) => {
      axios(requestBody).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
  patch(url, params) {
    return new Promise((resolve, reject) => {
      axios.patch(url, params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
  delete(url, params) {
    const token = store.state.LoginInfo.token
    if (token && !params) {
      params = {token: token}
    }
    if (params && token) {
      params.token = token
    }
    const requestBody = {
      method: 'DELETE',
      url: url,
      data: params
    }
    return new Promise((resolve, reject) => {
      axios(requestBody).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

let host = process.env.NODE_ENV === 'production' ? 'https://bbserver.pisugar.cn' : location.origin + '/pdt'

const http = new Axios()
// http response 拦截器

axios.interceptors.request.use(config => {
  try {
    let token = localStorage.loginToken
    if (token) {
      // config.headers['X-Token'] = token
    }
  } catch (e) {
    console.log(e)
  }
  return config
}, error => {
  return Promise.reject(error)
})
const errMsgs = ['Expired', 'Unauthorized', 'Not allow']
axios.interceptors.response.use(response => {
  // console.log(response)
  const data = response.data
  // console.log(this, this.logout)
  if (!data.ok && data.relogin) {
    const routerName = router.history.current.name
    if (routerName !== 'Login') {
      bus.$emit('showModal', {
        msg: data.err,
        callback: () => {
          bus.$emit('logout')
        }
      })
    }
  }
  return response
}, error => {
  if (error && error.response) {
    const errorRes = error.response
    const errorData = errorRes.data
    if (errorData.err) {
      bus.$emit('showModal', {
        msg: errorData.err
      })
    }
  }
  return Promise.reject(error)
})

export default {
  http: http,
  checkLoginInfo() {
    return http.post(host + '/ms/sign/info')
  },

  signInByPassword (params) {
    return http.post(host + '/ms/signin', params)
  },

  logout () {
    return http.post(host + '/ms/logout')
  },

  createNurse (params) {
    return http.post(host + '/ms/nurse/create', params)
  },

  async getNurseList (params) {
    let res = await http.get(host + '/ms/nurse/list', params)
    if (res.data.ok) store.dispatch('setNurseList', res.data.result)
  },

  async getNurseById (id) {
    let res = await http.get(host + '/ms/nurse/' + id)
    if (res.data.ok) store.dispatch('setNurse', res.data.result)
  },

  createBaby (params) {
    return http.post(host + '/ms/baby/create', params)
  },

  async getBabyList (nid, params) {
    let res = await http.get(host + '/ms/nurse/' + nid + '/baby', params)
    if (res.data.ok) store.dispatch('setBabyList', res.data.result)
  },

  async getRecordList (id, params) {
    let res = await http.get(host + '/ms/baby/' + id + '/record', params)
    if (res.data.ok) store.dispatch('setRecordList', res.data.result)
  },


}



// WEBPACK FOOTER //
// ./src/api/index.js